import { CSSProperties } from 'react'

export const listStyles: Record<string, CSSProperties> = {
  container: {
    width: '100%',
    overflowY: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
  },
  header: {
    backgroundColor: '#f5f5f5',
    borderBottom: '2px solid #ddd',
  },
  headerCell: {
    padding: '12px 16px',
    textAlign: 'left',
    fontWeight: 600,
  },
  row: {
    borderBottom: '1px solid #eee',
    cursor: 'pointer',
  },
  rowHover: {
    backgroundColor: '#f9f9f9',
  },
  cell: {
    padding: '12px 16px',
  },
  empty: {
    padding: '40px',
    textAlign: 'center',
    color: '#999',
  },
}

export const spinnerStyle: React.CSSProperties = {
  display: 'inline-block',
  animation: 'spin 1s linear infinite',
}
